import { Route, Routes } from 'react-router-dom';
import { useAuthGuard } from '../../user';

export const RevenueRoutes = () => {
  useAuthGuard();

  return (
    <Routes>
      <Route path="/" element={<>Revenue page</>} />
    </Routes>
  );
};
